import { t } from "i18next";
import features from "../../../utils/features.json";

export const createMonthlyPlans = (user) => [
    {
        features: [
            t('employer_plan.features.Instant_Job_Activation'),
            t('employer_plan.features.Applications_Per_Job'),
            t('employer_plan.features.Monthly_Jobs'),
            t('employer_plan.features.Jobseekers_DB_Access'),
            t('employer_plan.features.View_Applicant_Profile'),
            t('employer_plan.features.Contact_Applicant'),
            t('employer_plan.features.View_Download_Resume')
        ]
    },
    {
        name: t('employer_plan.SME'),
        price: `$${user?.subscription_price_sme_basic_for_1_month?.unit_amount / 100} /mo`,
        features: [
            Boolean(features.monthly.sme.instantJobActivation),
            JSON.stringify(features.monthly.sme.applicationsPerJob),
            JSON.stringify(features.monthly.sme.monthlyJobsLimit === 999999 ? t('general.UI.unlimited') : features.monthly.sme.monthlyJobsLimit),
            Boolean(features.monthly.sme.jobseekersDBAccess),
            Boolean(features.monthly.sme.viewApplicantProfile),
            JSON.stringify(features.monthly.sme.contactReveal),
            Boolean(features.monthly.sme.viewDownloadResume)
        ],
        link: "https://buy.stripe.com/test_9AQ17OfrBbLZcFyeV3",
        buttonText: getPlanButtonText(user, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR, true),
        priceId: process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH
    },
    {
        name: t('employer_plan.Basic'),
        price: `$${user?.subscription_price_basic_for_1_month?.unit_amount / 100} /mo`,
        features: [
            Boolean(features.monthly.basic.instantJobActivation),
            JSON.stringify(features.monthly.basic.applicationsPerJob),
            JSON.stringify(features.monthly.basic.monthlyJobsLimit),
            Boolean(features.monthly.basic.jobseekersDBAccess),
            Boolean(features.monthly.basic.viewApplicantProfile),
            JSON.stringify(features.monthly.basic.contactReveal),
            Boolean(features.monthly.basic.viewDownloadResume)
        ],
        link: "https://buy.stripe.com/test_00wfZjcs92JG5na1mU08g0h",
        buttonText: getPlanButtonText(user, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR),
        priceId: process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH
    },
    {
        name: t('employer_plan.Free'),
        price: "$0",
        features: [
            Boolean(features.monthly.free.instantJobActivation),
            JSON.stringify(features.monthly.free.applicationsPerJob),
            JSON.stringify(features.monthly.free.monthlyJobsLimit),
            Boolean(features.monthly.free.jobseekersDBAccess),
            Boolean(features.monthly.free.viewApplicantProfile),
            features.monthly.free.contactReveal == 0 ? false : JSON.stringify(features.monthly.free.contactReveal),
            Boolean(features.monthly.free.viewDownloadResume)
        ],
        link: "https://buy.stripe.com/test_fZe17O2EP5nBbBu3cn",
        buttonText: getFreePlanButtonText(user),
        priceId: 'free'
    },
];

export const createAnnualPlans = (user) => [
    {
        features: [
            t('employer_plan.features.Instant_Job_Activation'),
            t('employer_plan.features.Applications_Per_Job'),
            t('employer_plan.features.Monthly_Jobs'),
            t('employer_plan.features.Jobseekers_DB_Access'),
            t('employer_plan.features.View_Applicant_Profile'),
            t('employer_plan.features.Contact_Applicant'),
            t('employer_plan.features.View_Download_Resume'),
        ]
    },
    {
        name: t('employer_plan.SME'),
        price: `$${user?.subscription_price_sme_basic_for_1_year?.unit_amount / 100}`,
        features: [
            Boolean(features.semiannual.sme.instantJobActivation),
            JSON.stringify(features.semiannual.sme.applicationsPerJob),
            JSON.stringify(features.semiannual.sme.monthlyJobsLimit === 999999 ? t('general.UI.unlimited') : features.semiannual.sme.monthlyJobsLimit),
            Boolean(features.semiannual.sme.jobseekersDBAccess),
            Boolean(features.semiannual.sme.viewApplicantProfile),
            JSON.stringify(features.semiannual.sme.contactReveal),
            Boolean(features.semiannual.sme.viewDownloadResume)
        ],
        link: "https://buy.stripe.com/test_4gM3cxbo52JGaHud5C08g0e",
        buttonText: getPlanButtonText(user, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH, true, true),
        priceId: process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR
    },
    {
        name: t('employer_plan.Basic'),
        price: `$${user?.subscription_price_basic_for_1_year?.unit_amount / 100}`,
        features: [
            Boolean(features.semiannual.basic.instantJobActivation),
            JSON.stringify(features.semiannual.basic.applicationsPerJob),
            JSON.stringify(features.semiannual.basic.monthlyJobsLimit),
            Boolean(features.semiannual.basic.jobseekersDBAccess),
            Boolean(features.semiannual.basic.viewApplicantProfile),
            JSON.stringify(features.semiannual.basic.contactReveal),
            Boolean(features.semiannual.basic.viewDownloadResume)
        ],
        link: "https://buy.stripe.com/test_5kQ5kF63Lfws3f2e9G08g0g",
        buttonText: getPlanButtonText(user, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR, process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH, false, true),
        priceId: process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR
    },
    {
        name: t('employer_plan.Free'),
        price: "$0",
        features: [
            Boolean(features.semiannual.free.instantJobActivation),
            JSON.stringify(features.semiannual.free.applicationsPerJob),
            JSON.stringify(features.semiannual.free.monthlyJobsLimit),
            Boolean(features.semiannual.free.jobseekersDBAccess),
            Boolean(features.semiannual.free.viewApplicantProfile),
            features.semiannual.free.contactReveal == 0 ? false : JSON.stringify(features.semiannual.free.contactReveal),
            Boolean(features.semiannual.free.viewDownloadResume)
        ],
        link: "https://buy.stripe.com/test_00gbMsbbl9DR9tmeV6",
        buttonText: getFreePlanButtonText(user),
        priceId: 'free'
    },
];

// Helper function to determine plan button text
function getPlanButtonText(user, currentPlanId, otherPeriodPlanId, isSME = false, isAnnual = false) {
    // Check if user is an employer with autoRenewal disabled
    if (user?.account_type === 'employer' && user?.subscriptionDetail?.cancel_at_period_end === true) {
        return '';  // Return empty string to hide the button
    }

    if (!user?.subscriptionStatus) {
        return t('plans.1_month_plan.button_text');
    }

    if (user?.subscriptionStatus?.toUpperCase() !== 'ACTIVE') {
        return t('plans.1_month_plan.button_text');
    }

    // If this is the active plan
    if (user?.activeSubscriptionPriceId === currentPlanId) {
        return 'active';
    }

    // If this is the same plan type but different period
    if (user?.activeSubscriptionPriceId === otherPeriodPlanId) {
        // For annual plans, always show "upgrade" when coming from monthly
        if (isAnnual) {
            return t('pricing.upgrade');
        }
        return isSME ? t('pricing.upgrade') : t('pricing.downgrade');
    }

    // If current plan is SME and target is basic
    if (isSME && (
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH ||
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR
    )) {
        return t('pricing.upgrade');
    }

    // If current plan is Basic and target is SME
    if (!isSME && (
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH ||
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR
    )) {
        return t('pricing.downgrade');
    }

    return t('pricing.upgrade');
}

// Helper function to determine free plan button text
function getFreePlanButtonText(user) {
    // Check if user is an employer with autoRenewal disabled
    if (user?.account_type === 'employer' && user?.subscriptionDetail?.cancel_at_period_end === true) {
        return '';  // Return empty string to hide the button
    }

    if (!user?.subscriptionStatus) {
        return t('plans.1_month_plan.button_text');
    }

    if (user?.subscriptionStatus?.toUpperCase() !== 'ACTIVE') {
        return t('plans.1_month_plan.button_text');
    }

    if (user?.activeSubscriptionPriceId === 'free') {
        return 'active';
    }

    return t('pricing.downgrade');
} 